import { render, staticRenderFns } from "./AcademicRenewalHomePage.vue?vue&type=template&id=498a4d9c"
import script from "./AcademicRenewalHomePage.vue?vue&type=script&lang=js"
export * from "./AcademicRenewalHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports